// @flow
import * as React from 'react';
import invariant from 'invariant';
import { isDefined, randomInt } from 'utils/functional';
import { FilestackImage } from 'components/Image';
import type { Subsite } from 'api/website';

const randomElement = arr => arr[randomInt(arr.length)];

const makeKey = id => `placeholderImg:${id}`;

const PlaceholderPostImage = ({
  postId,
  subsite,
  ...props
}: {
  postId: string,
  subsite: Subsite,
  alt: string,
  height: number,
  width: number,
  fit: string
}) => {
  invariant(
    isDefined(localStorage),
    'Placeholder image uses local storage (browser)'
  );
  const storedHandle = localStorage.getItem(makeKey(postId));
  const randomItem = randomElement(subsite.placeholderImages);
  const image =
    subsite.placeholderImages.find(i => i.handle === storedHandle) ||
    (() => {
      localStorage.setItem(makeKey(postId), randomItem.handle);
      return randomItem;
    })();

  return <FilestackImage {...props} data={image} />;
};

export default PlaceholderPostImage;
